/*
 * Code generated by Speakeasy (https://speakeasy.com). DO NOT EDIT.
 * @generated-id: a90e8950d8e0
 */

import * as z from "zod";

export type ComponentsDestroyRequest = {
  asset_id: string;
  invalidate?: boolean | undefined;
  notification_url?: string | undefined;
  callback?: string | undefined;
};

export const ComponentsDestroyRequest$zodSchema: z.ZodType<
  ComponentsDestroyRequest
> = z.object({
  asset_id: z.string().describe("A 32-character hexadecimal asset ID."),
  callback: z.string().optional().describe(
    "URL for redirect after operation completion.",
  ),
  invalidate: z.boolean().optional().describe(
    "Whether to invalidate CDN cache. Default is false.",
  ),
  notification_url: z.string().optional().describe(
    "URL to receive completion notification.",
  ),
});
